import { useEffect } from "react";
import Stage from "./components/Stage.jsx";
import SettingsPanel from "./components/SettingsPanel.jsx";
import LensLibraryPage from "./components/LensLibraryPage.jsx";
import UtilityDialog from "./components/UtilityDialog.jsx";
import { LensAppProvider, useLensApp } from "./useLensApp.jsx";

function Root() {
  const { settingsCollapsed, debugOverlayVisible } = useLensApp();
  const library = window.location.pathname.replace(/\/+$/, "") === "/ui/lenses";
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    root.classList.toggle("settings-collapsed", Boolean(settingsCollapsed));
    root.classList.toggle("debug-overlay", Boolean(debugOverlayVisible));
  }, [settingsCollapsed, debugOverlayVisible]);

  if (library) return <><LensLibraryPage /><UtilityDialog /></>;
  return (
    <>
      <Stage />
      <SettingsPanel />
      <UtilityDialog />
    </>
  );
}

export default function App() {
  return (
    <LensAppProvider>
      <Root />
    </LensAppProvider>
  );
}
